import { AdKind } from '@/api/types/common.types';

type PaidUntilAdKind = Exclude<AdKind, AdKind.Bumped>;
type PaidUntilField = 'vippedUntil' | 'featuredUntil';

export const PAID_UNTIL_TYPES: Record<PaidUntilAdKind, PaidUntilField> = {
  [AdKind.Vipped]: 'vippedUntil',
  [AdKind.Premium]: 'featuredUntil',
};
